import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import ScrollToTop from "./pages/ScrollToTop";
import CoursesFull from "./components/CoursesFull";
import EnrollForm from "./pages/EnrollForm";
import DemoSession from "./components/DemoSession";
import Consultation from "./components/Consultations";
const HomePage = lazy(() => import("./pages/HomePage"));
const CourseDetail = lazy(() => import("./components/CourseDetail"));
const Login = lazy(() => import("./pages/Login"));
const ManageCourses = lazy(() => import("./pages/ManageCourses"));
const Enrollments = lazy(() => import("./pages/Enrollments"));
const HomeSettings = lazy(() => import("./pages/HomeSettings"));
const Blog = lazy(() => import("./pages/Blog"));
const Contact = lazy(() => import("./pages/Contact"));
const AdminAddBlog = lazy(() => import("./pages/AdminAddBlog"));
const EditBlog = lazy(() => import("./pages/EditBlog"));
const BlogDetails = lazy(() => import("./pages/BlogDetails"));
const AdminAbout = lazy(() => import("./pages/AdminAbout"));
const AddWhyUs = lazy(() => import("./pages/AddWhyUs"));
const AdminTestimonials = lazy(() => import("./pages/AdminTestimonials"));
const AddWhoWeServe = lazy(() => import("./pages/AddWhoWeServe"));
const CourseFeaturesAdmin = lazy(
  () => import("./pages/AdminCourseSidebarFeatures"),
);
const AdminLoginUsers = lazy(() => import("./pages/AdminLoginUsers"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsConditions = lazy(() => import("./pages/TermsConditions"));
const Disclaimer = lazy(() => import("./pages/Disclaimer"));
const RefundPolicy = lazy(() => import("./pages/RefundPolicy"));
const AdminDemoSessions = lazy(() => import("./pages/AdminDemoSessions"));
const AdminConsultations = lazy(() => import("./pages/AdminConsultations"));
const LiveDemoPopup = lazy(() => import("./components/LiveDemoPopup"));
const AboutFull = lazy(() => import("./components/AboutFull"));
const WhyusFull = lazy(() => import("./components/WhyusFull"));

function App() {
  const [showPopup, setShowPopup] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);
  return (
    <Router basename="/">
      <ScrollToTop />

      {showPopup && <LiveDemoPopup />}
      <Suspense
        fallback={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              fontSize: "20px",
            }}
          >
            Loading...
          </div>
        }
      >
        <Routes>
          {/* ================= HOME ================= */}

          <Route path="/" element={<HomePage />} />

          <Route path="/about" element={<HomePage />} />

          <Route path="/whyus" element={<HomePage />} />

          {/* <Route
          path="/contact-us"
          element={<HomePage />}
        /> */}

          <Route path="/testimonials" element={<HomePage />} />

          <Route path="/training" element={<HomePage />} />

          {/* ================= ABOUT (FULL PAGE) =================
            Destination of the "View More" button in the home page
            About section. Renders its own Navbar internally, so it
            is NOT wrapped in <Navbar/> here (same pattern as
            /blogs, /contact-us, /courses/:slug below).

            NOTE: Who We Serve now lives inside this page (merged
            into AboutFull.jsx) instead of its own home page section,
            so this is also where that content is reached from. */}

          <Route path="/about-us" element={<AboutFull />} />

          <Route path="/why-swiftintelli" element={<WhyusFull />} />
          <Route path="/join-free-demo/:slug" element={<DemoSession />} />

          <Route path="/consultation" element={<Consultation />} />

          {/* ================= LOGIN ================= */}

          <Route path="/login" element={<Login />} />

          {/* ================= BLOG ================= */}

          <Route path="/blogs" element={<Blog />} />

          <Route path="/blogs/:slug" element={<BlogDetails />} />

          {/* ================= CONTACT ================= */}

          <Route path="/contact-us" element={<Contact />} />

          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          <Route path="/terms-and-conditions" element={<TermsConditions />} />

          <Route path="/disclaimer" element={<Disclaimer />} />

          <Route
            path="/refund-cancellation-policy"
            element={<RefundPolicy />}
          />

          {/* ================= COURSES ================= */}

          <Route path="/ourcourses" element={<HomePage />} />

          <Route path="/courses/:slug" element={<CourseDetail />} />
          <Route path="/courses" element={<CoursesFull />} />

          {/* ================= ADMIN ================= */}

          <Route
            path="/manage-courses"
            element={
              <>
                <Navbar />
                <ManageCourses />
              </>
            }
          />

          <Route
            path="/enrollments"
            element={
              <>
                <Navbar />
                <Enrollments />
              </>
            }
          />

          <Route
            path="/home-settings"
            element={
              <>
                <Navbar />
                <HomeSettings />
              </>
            }
          />

          <Route path="/enroll/:slug" element={<EnrollForm />} />
          {/* ================= BLOG ADMIN ================= */}

          <Route
            path="/admin-add-blog"
            element={
              <>
                <Navbar />
                <AdminAddBlog />
              </>
            }
          />

          <Route
            path="/edit-blog/:id"
            element={
              <>
                <Navbar />
                <EditBlog />
              </>
            }
          />

          {/* ================= ABOUT ADMIN ================= */}

          <Route
            path="/admin-about"
            element={
              <>
                <Navbar />
                <AdminAbout />
              </>
            }
          />

          {/* ================= WHY US ADMIN ================= */}

          <Route
            path="/admin-whyus"
            element={
              <>
                <Navbar />
                <AddWhyUs />
              </>
            }
          />

          <Route
            path="/admin-who-we-serve"
            element={
              <>
                <Navbar />
                <AddWhoWeServe />
              </>
            }
          />

          <Route
            path="/admin-testimonials"
            element={
              <>
                <Navbar />
                <AdminTestimonials />
              </>
            }
          />

          <Route
            path="/admin-course-features"
            element={
              <>
                <Navbar />
                <CourseFeaturesAdmin />
              </>
            }
          />

          {/* ================= DEMO SESSIONS ADMIN ================= */}

          <Route
            path="/admin-demo-sessions"
            element={
              <>
                <Navbar />
                <AdminDemoSessions />
              </>
            }
          />

          {/* ================= CONSULTATIONS ADMIN ================= */}

          <Route
            path="/admin-consultations"
            element={
              <>
                <Navbar />
                <AdminConsultations />
              </>
            }
          />

          <Route
            path="/login-users"
            element={
              <>
                <Navbar />
                <AdminLoginUsers />
              </>
            }
          />
          {/* ================= 404 ================= */}

          <Route
            path="*"
            element={
              <div
                style={{
                  textAlign: "center",
                  marginTop: "120px",
                  fontSize: "32px",
                  fontWeight: "600",
                }}
              >
                Page Not Found ❌
              </div>
            }
          />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
